import { useUserSelector } from './useUserSelector';

export const useStateGuard = (whitelisted: string[]) => {
  const { address } = useUserSelector();

  return whitelisted.includes(address?.[0]?.state || '');
};
